<template>
    <div class="animated fadeIn">
        <b-modal ref="modal-newRule" scrollable centered button-size="sm" v-on:hide="hideModal" v-on:close="hideModal">
            <template #modal-title>
                <i class="fas fa-random"></i>&nbsp; NOVA REGRA
            </template>
            <div class="newRule__inputs__container row">
              <div class="col-md-12">
                <NxInput
                  validation="min:1"
                  :validation-messages="{ min: 'Valor deve ser maior que zero.' }"
                  error-behavior="value"
                  required
                  name="timeLimit"
                  type="number"
                  label="Tempo máximo no quadro (horas)"
                  placeholder="Digite o tempo limite"
                  :value="form.tempoAtraso"
                  v-model="form.tempoAtraso"
                />
              </div>
              <div class="col-md-12">
                <NxSelectQuadroColuna
                  required
                  :value="form.boardColumnId"
                  :boardId="boardObj.id"
                  :onlyActive="true"
                  @update:value="form.boardColumnId = $event"
                />
              </div>
            </div>
            <template #modal-footer>
                <div class="w-100 text-right">
                    <button type="button" class="btn rounded btn-default btn-sm text-secundary" v-on:click="onClear"
                        v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonClear"><i class="fa fa-minus-circle mr-1"></i>
                        <span class="d-md-down-none">{{ $lang.Common.Buttons.Clear }}</span></button>&nbsp;
                    <button :disabled="!readyToSave" type="button" class="btn rounded btn-third btn-sm" v-on:click="onSave"
                        v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"> <i class="fas fa-check-circle mr-1"></i>
                        <span class="d-md-down-none">{{ $lang.Common.Buttons.Save }}</span></button>&nbsp;
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { NxSelectQuadroColuna } from '@/components/nexum/components/custom-selects/index.js'
import { toast } from '@/shared/utils/UIHelper'
import columnRuleTypes from '@/views/private/crm/board/modal/collumns/movimentacao-coluna/enumTiposRegra.js'
import MovAutoCardRepository from '@/shared/http/repositories/crm/movimentacaoAutoCard.js'

export default {
  name: 'ModalNewRule',
  props: {
    boardObj: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      ruleTypes: columnRuleTypes,
      form: {
        tempoAtraso: null,
        boardColumnId: null,
        inative: false
      },
      boardColumnOptions: []
    }
  },
  components: { NxSelectQuadroColuna },
  computed: {
    readyToSave () {
      return this.form && this.form.tempoAtraso && this.form.boardColumnId
    }
  },
  created () {
    this.onLoadBoardColumns()
  },
  mounted () {
    if (this.isEditing) {
      this.dataToForm()
    }
    this.showModal()
  },
  methods: {
    showModal () {
      this.$refs['modal-newRule'].show()
    },
    hideModal () {
      this.$emit('HideModal')
    },
    hideModalSucess () {
      this.$emit('Reload')
    },
    onSave () {
      if (this.isEditing) {
        this.onEdit()
        return
      }

      let data = this.formatData()
      let idCurrentBoard = this.boardObj.id

      MovAutoCardRepository.CreateBoard(idCurrentBoard, data)
        .then(() => {
          toast.success('A regra foi salva com sucesso!', 'Parabéns')
          this.hideModalSucess()
        })
        .catch((e) => {
          toast.error('Não foi possível salvar a regra.', 'Desculpe')
          console.error(e)
        })
    },
    onEdit () {
      let data = this.formatData()
      MovAutoCardRepository.Update(data)
        .then(() => {
          toast.success('A regra foi editada com sucesso!', 'Parabéns')
          this.hideModalSucess()
        })
        .catch((e) => {
          toast.error('Não foi possível editar a regra.', 'Desculpe')
          console.error(e)
        })
    },
    onClear () {
      this.$root.$emit('clearForm')
    },
    formatData () {
      let type = 1
      let time = parseInt(this.form.tempoAtraso)
      let bcId = parseInt(this.form.boardColumnId)

      let data = {
        tipoRegra: type,
        horas: time,
        boardColumnDestino: bcId,
        inative: this.form.inative,
        id: this.form.id ? this.form.id : null
      }
      return data
    },
    dataToForm () {
      this.form = {
        tipoRegra: this.isEditing.tipoRegra,
        tempoAtraso: this.isEditing.tempoAtraso,
        inative: this.isEditing.inative,
        boardColumnId: this.isEditing.boardColumn.id,
        id: this.isEditing.id
      }
    }
  }
}

</script>
<style lang="scss">
.formulate-input-element.formulate-input-element--textarea {
    max-width: 100% !important;
}

.newRule__inputs__container {
    display: flex;
    gap: 1rem;
    justify-content: space-between;

    .formulate-input {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/collumns/movimentacao-quadro/ModalNewRule.vue